import moment from "moment";
import React from "react";
import useLocalPagination from "../../Common/useLocalPagination";

const MembersList = ({ members }) => {
  const {
    currentPage,
    pageSize,
    totalPages,
    totalRecords,
    paginatedData,
    handlePageChange,
    handlePageSizeChange,
    handleNextPage,
    handlePreviousPage,
    slicePageData,
    setPaginatedData,
    setTotalPages,
    setTotalRecords,
    setCurrentPage,
    setPageSize,
    handleFirstPage,
    handleLastPage,
    currentPageIndexes,
    previousPage,
    nextPage,
  } = useLocalPagination(members);

  return (
    <>
      <div
        className="participant"
        style={{
          maxHeight: "200px",
          overflowY: "scroll",
          paddingRight: "1rem",
        }}
      >
        {paginatedData?.map((member) => (
          <div className="participant__item">
            <div className="participant__profile">
              <div className="initials">
                {member?.avatar ? (
                  <img src={member?.avatar} alt="profile" />
                ) : (
                  `${String(member?.firstName)[0]}${
                    String(member?.lastName)[0]
                  }`
                )}
              </div>
              <div className="info">
                <h4 className="name">{`${member?.firstName} ${member?.lastName}`}</h4>
                <p className="para">{member?.email}</p>
              </div>
            </div>
            <div className="participant__info">
              <h4 className="date">
                {moment.utc(member?.createdAt).local().format("DD/MM/YYYY")}
              </h4>
              <p className="para">Date Added</p>
            </div>
          </div>
        ))}
      </div>

      <div className="pagination">
        <div className="pagination__result">
          {currentPageIndexes.start}-{currentPageIndexes.end} of{" "}
          {totalRecords ? totalRecords : "0"} items
        </div>
        <nav
          aria-label="pagination navigation"
          className="MuiPagination-root MuiPagination-outlined css-1oj2twp-MuiPagination-root"
        >
          <ul className="MuiPagination-ul css-wjh20t-MuiPagination-ul">
            <li onClick={handleFirstPage}>
              <button
                className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="-1"
                type="button"
                disabled={currentPage < 2}
                aria-label="Go to first page"
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.83333 11.3332L4.5 7.99984L7.83333 4.6665M12.5 11.3332L9.16667 7.99984L12.5 4.6665"
                    stroke="#150823"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </li>
            <li onClick={handlePreviousPage}>
              <button
                className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="-1"
                type="button"
                disabled={currentPage < 2}
                aria-label="Go to previous page"
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5 12L6.5 8L10.5 4"
                    stroke="#150823"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </li>
            {previousPage && !nextPage ? (
              <li onClick={handlePreviousPage}>
                <button
                  className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                  tabindex="0"
                  type="button"
                  aria-label="Go to page 2"
                >
                  {previousPage}
                  <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
                </button>
              </li>
            ) : (
              ""
            )}
            {currentPage ? (
              <li>
                <button
                  className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-selected MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                  tabindex="0"
                  type="button"
                  aria-current="true"
                  aria-label="page 1"
                >
                  {currentPage}
                  <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
                </button>
              </li>
            ) : null}
            {nextPage ? (
              <li onClick={handleNextPage}>
                <button
                  className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                  tabindex="0"
                  type="button"
                  aria-label="Go to page 2"
                >
                  {nextPage}
                  <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
                </button>
              </li>
            ) : (
              ""
            )}
            <li onClick={handleNextPage}>
              <button
                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="0"
                type="button"
                disabled={currentPage === totalPages}
                aria-label="Go to next page"
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.5 12L10.5 8L6.5 4"
                    stroke="#150823"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            </li>
            <li onClick={handleLastPage}>
              <button
                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="0"
                type="button"
                disabled={currentPage === totalPages}
                aria-label="Go to last page"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.66667 11.3332L12 7.99984L8.66667 4.6665M4 11.3332L7.33333 7.99984L4 4.6665"
                    stroke="#150823"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            </li>
          </ul>
        </nav>

        <div className="pagination__actions" />
      </div>
    </>
  );
};

export default MembersList;
